import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Skeleton from '@wecasa/web-ui/src/components/skeleton/skeleton';

type AccordionTitlePriceProps = {
  formattedPrice: string;
  formattedFollowingSessionsPrice?: string;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isLoadingPrices: boolean;
};

export const AccordionTitlePrice = ({
  formattedPrice,
  formattedFollowingSessionsPrice,
  isITCSelectedOrSuccessfullyPaired,
  isLoadingPrices,
}: AccordionTitlePriceProps) => {
  if (isLoadingPrices) return <Skeleton linesWidth={['70px']} />;

  if (formattedFollowingSessionsPrice) return <Text>{formattedFollowingSessionsPrice}</Text>;

  return <Text strikedOut={isITCSelectedOrSuccessfullyPaired}>{formattedPrice}</Text>;
};
